import React, { Component } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { withStyles } from '@material-ui/core/styles';
import {isEmpty, isUndefined} from 'lodash'
import {connect} from 'react-redux';

import './custom.css'

const styles = (theme) => ({
  
  editorStyle: {
    minHeight: 200,
    height: 'calc(100% - 38px)',
    '& .cke_chrome' : { 
      border: 'none',
    },
    '& .cke .cke_bottom' : { 
      backgroundColor: 'transparent',
      borderRadius: '0px 0px 0px 10px' 
    },
    '& .cke .cke_top' : { 
      backgroundColor: 'transparent'
      // borderRadius: '0px 0px 0px 10px' 
    },
    '& .cke .cke_inner' : { 
      backgroundColor: 'transparent'
      // borderRadius: '0px 0px 0px 10px' 
    }
    },
});


class NotEditor extends Component {
    constructor(props) {
        super(props);
        
        this.myRef = React.createRef();
        this.updateContent = this.updateContent.bind(this);
        this.state = {
          content: this.props.commentText,
          config: {
            toolbar: [ { name: 'basicstyles', items: [ 'Bold', 'Italic', 'Underline', 'Strike',  '-', 'RemoveFormat' ] },
            { name: 'paragraph', items: [ 'NumberedList', 'BulletedList','-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl' ] },
            { name: 'insert', items: [  'HorizontalRule' ] },
            { name: 'colors', items: [ 'TextColor', 'BGColor' ] } ,
            { name: 'styles', items: [ 'FontSize' ] }
            
          ],
          // enterMode: window.CKEDITOR.ENTER_BR,
          removePlugins: 'elementspath',
          extraPlugins: "colorbutton,font,justify",
          width: "100%",
          height: isUndefined(this.props.height) ? "250px" : 'calc(100vh - 180px)',
          maxHeight: isUndefined(this.props.height) ? "370px" : 'unset',
          resize_enabled:false,
          font_names :
              'Arial/Arial, Helvetica, sans-serif;' +
              'Times New Roman/Times New Roman, Times, serif;' +
              'Verdana'
          }
        }
      }
    
      updateContent(newContent) {
        this.props.handleupdatecommentText(newContent)
      }
    
      onChange(data) {
        // data = this.getContent()
        // const newContent = evt.editor.getData();
        // this.setState({content: data})
        this.props.handleupdatecommentText(data)
      }
      componentDidUpdate=()=>{
        if(this.state.content !== this.props.commentText){
          this.setState({
            content: this.props.commentText
          })
        }
      }
      getLang(lang) {
        switch(lang.locale) {
          case "sv": return 'sv_SE';
          case "no": return 'no_NO';
          case "en": return 'en_US';
          default: return 'sv_SE';
        }
      }
      render() {
        const {handleupdatecommentText, classes} = this.props
        console.log(this.props.locale, 'COMMENT TEXT')
        let lang = 'sv_SE'
        try {
          lang = this.getLang(this.props.locale)
        }
        catch(e) {
          console.error(e)
        }
        return (
          <div className={classes.editorStyle}>
              <Editor
              disabled={this.props.disabled}
		  	tabIndex={1}
        tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
			onEditorChange={(value) => {this.onChange(value)}}
			// onChange={(e,v) => {this.onChange(e,v)}}
      onInit={(evt, editor) => {
				// this.myRef.current = editor
        // editor.on('drop', function (e, evt) {
        //   console.log(e.dataTransfer.files, 'FILE DROP!')
        //   console.log(e , 'FILE DROP!')
        //   console.log(e.dataTransfer , 'FILE DROP!')
        //     let files = []
        //     for (let i = 0; i < e.dataTransfer.files.length; i++) {
        //       const file = e.dataTransfer.files[i];
        //       if(!String(file.type).includes('image')) files.push(file)
        //     }
        //     if(!isEmpty(files) && !isUndefined()) {
              
        //     }
				//   });
      }}
			value={this.props.commentText}
			init={{
        force_br_newlines : true,
        force_p_newlines : false,
        forced_root_block : '',
				menubar: false,
				inline: false,
				draggable_modal: true,
				resize: false,
				paste_block_drop: false,
        paste_data_images : false,
        paste_as_text: true,
				branding: false,
        statusbar: false,
				selector: 'textarea',
        browser_spellcheck: true,
        contextmenu: false,
        file_browser_callback_types: 'file image media',
        file_browser_callback: function(field_name, url, type, win) {
          console.log('FILEEEEEEE')
        },
        plugins: 
          'advlist autolink lists link image charmap preview anchor ' +
          'searchreplace visualblocks code fullscreen ' +
          'insertdatetime media table help wordcount table ',
				// table_appearance_options: false,
				font_size_formats: "8px 10px 12px 14px 16px 18px 24px 36px 48px 60px 72px 84px 96px 108px 120px",
				// external_plugins: {
				// 	bubbleBar: "http://www.leofec.com/assets/tinymceBubbleBar.js", // file location
				// },
        min_height: 200,
        max_height: isUndefined(this.props.height) ? 300 : 'unset',
        height: isUndefined(this.props.height) ? 400 : '100%',
				toolbar: 'undo redo | fontsize  | ' +
				'link fontLight bold italic underline forecolor | bullist numlist alignment outdent indent | ' +
				`| help `,
				table_sizing_mode: 'responsive ',
				table_column_resizing: 'resizetable',

				font_family_formats: `
					Titillium=Titillium Web, sans-serif;
					Ubuntu=Ubuntu, Arial, sans-serif;
					Lucida Sans Unicode=Lucida Sans Unicode, Lucida Grande, sans-serif;
					Tahoma=Tahoma, Geneva, sans-serif;
					Times New Roman=Times New Roman, Times, serif;
					Trebuchet MS=Trebuchet MS, Helvetica, sans-serif;
					Verdana=Verdana, Geneva, sans-serif;
					Arial=Arial, Helvetica, sans-serif;
					Calibri=Calibri, sans-serif;
					Open Sans=Open Sans, sans-serif;
					Lato=Lato, sans-serif;
					Montserrat=Montserrat, sans-serif;
          Interstate=Interstate;
          Cabin=Cabin
					`,

				toolbar_groups: {
					formatting: {
					  icon: 'format',
					  tooltip: 'Formateringar',
					  items: 'link bold italic underline backcolor forecolor'
					},
					alignment: {
						icon: 'align-left',
						tooltip: 'Text inriktningar',
						items: ' alignleft aligncenter alignright alignjustify'
					}
				  },

				content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
				language_url: process.env.PUBLIC_URL + `/langsTinymce/${lang}.js`,
        language: lang,

				//styleselect -- toolbar
				style_formats: [ 
					{ title: '100', format: 'fw100' },
					{ title: '200', format: 'fw200' },
					{ title: '300', format: 'fw300' },
					{ title: '400', format: 'fw400' },
					{ title: '500', format: 'fw500' },
					{ title: '600', format: 'fw600' },
					{ title: '700', format: 'fw700' },
					{ title: '800', format: 'fw800' },
					{ title: '900', format: 'fw900' },
				],
			}}
		/>
          </div>
        )
      }
}
const mapStateToProps = ({settings}) => {
  const { locale} = settings;
  return {locale}
};

export default connect(mapStateToProps)(withStyles(styles)(NotEditor));